import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'

import Mobile from './HOC/Mobile'
import Analytics from './HOC/Analytics'
import Title from './HOC/Title'
import ForgotPassword from '../components/ForgotPassword'

function ForgotPasswordContainer({ data, location }) {
  return <ForgotPassword data={data} search={qs.parse(location.search)} />
}

ForgotPasswordContainer.propTypes = {
  location: PropTypes.object,
}

export default Title(Analytics(Mobile(ForgotPasswordContainer)), 'Recuperar senha – Hi Platform')



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword.js